import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './config/msalConfig';
import LoginPage from './components/LoginPage';
import HomePage from './components/HomePage';
import EditContent from './components/EditContent';
import authService from './services/authService';

// Initialize MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    // Check if user is already logged in
    const checkAuth = async () => {
      const isAuth = authService.isAuthenticated();
      console.log('App.tsx - checking authentication status:', isAuth);
      
      // Validate token if exists
      if (isAuth) {
        const isValid = await authService.validateToken();
        if (!isValid) {
          // Token is invalid, clear storage
          await authService.logout();
          setIsLoggedIn(false);
        } else {
          setIsLoggedIn(true);
        }
      } else {
        setIsLoggedIn(false);
      }
      
      setIsLoading(false);
    };
    
    checkAuth();
  }, []);

  // Listen for storage changes to update login state
  useEffect(() => {
    const handleStorageChange = () => {
      const loginStatus = localStorage.getItem('isLoggedIn');
      console.log('Storage changed, new login status:', loginStatus);
      setIsLoggedIn(loginStatus === 'true');
    };

    // Check for login status changes periodically (for same-window updates)
    const intervalId = setInterval(() => {
      const loginStatus = localStorage.getItem('isLoggedIn');
      const currentStatus = loginStatus === 'true';
      if (currentStatus !== isLoggedIn) {
        console.log('Login status changed:', currentStatus);
        setIsLoggedIn(currentStatus);
      }
    }, 500);

    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(intervalId);
    };
  }, [isLoggedIn]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <MsalProvider instance={msalInstance}>
      <Router>
        <div className="App">
          <Routes>
            <Route 
              path="/" 
              element={isLoggedIn ? <Navigate to="/home" replace /> : <LoginPage />} 
            />
            <Route 
              path="/login" 
              element={isLoggedIn ? <Navigate to="/home" replace /> : <LoginPage />} 
            />
            <Route 
              path="/home" 
              element={isLoggedIn ? <HomePage /> : <Navigate to="/" replace />} 
            />
            <Route 
              path="/edit-content" 
              element={isLoggedIn ? <EditContent /> : <Navigate to="/" replace />} 
            />
          </Routes>
        </div>
      </Router>
    </MsalProvider>
  );
}

export default App;
